export class CondicaoPagamentoOptions {
    canImportErp_v1: boolean;
    canImport: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canImportErp_v1 ||
            this.canImport;
    }
}
